import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs';
declare const require;
@Injectable({
  providedIn: 'root'
})
export class ShareDataService {
  public langSub: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public addDriver: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  public addTruck: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  public addVehicle: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  public truckIndexValue: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public driverIndexValue: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public vehicleIndexValue: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public editProfileStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public myAccountSection: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public truckOwnerId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public getUser: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public setUserAccountSectionAccess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public reuseTrip_TripId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public createFreightShipment: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public addShipmentDetails: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public isCreatingNewTrip: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public editShipment: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public editResueSimilarTrip: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public remainingDistanceAndDuration: BehaviorSubject<Object> = new BehaviorSubject<Object>({});
  public getTripStatus: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() { }

  setLang(lang) {
    let langJSON = lang =='en' ? require('../../assets/i18n/en.json') : require('../../assets/i18n/ar.json');
    this.langSub.next({ lang: lang,json:langJSON });
  }

  getLang(): Observable<any> {
    return this.langSub.asObservable();
  }
  isValidImage(filename){
    if (filename.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/i)) {
      return true;
    }else{
      return false;
    }
  }
}
